export const ShareAppModal = () => null
